(($, window) => {
    // Script loads in footer so don't need to wait for document ready

    $('form.grc-v3').on('submit', e => {
        
        if (!$('#recap-v3').val()) {
            e.preventDefault();
            grecaptcha.ready(function () {
                grecaptcha.execute(BLVC_PUBLIC_DATA.grc_site_key, { action: 'apply' }).then(function (token) {
                    // Add your logic to submit to your backend server here.
                    $('#recap-v3').val(token);
                    $(e.currentTarget).submit();
                });
            });
        }
        else {
            return true;
        }
    });
})(jQuery, window);
